<template>
  <b-container fluid>
    <TopBar id="top-bar" :nom="epreuve.nom_epreuve" :date="epreuve.date_epreuve" :ville="epreuve.ville_competition" :id_epreuve="epreuve.id"></TopBar>
    <!-- Permet de filtrer les résultats -->
    <b-row id="selector-bar">
      <b-col sm="12" md="6">
        <SelectionCourse v-if="epreuve.list_courses && epreuve.list_courses.length > 0" :list_courses="epreuve.list_courses" :id_epreuve="epreuve.id"></SelectionCourse>
      </b-col>
      <b-col sm="12" md="6">
        <SelectionChallenge v-if="epreuve.challenges && epreuve.challenges.length > 0" :current_challenge="current_challenge" :challenges="epreuve.challenges" :id_epreuve="epreuve.id"> </SelectionChallenge>
        <SelectionChallengeEquipe v-if="epreuve.challenges_equipe && epreuve.challenges_equipe.length > 0" :current_challenge="current_challenge_equipe" :challenges="epreuve.challenges_equipe" :id_epreuve="epreuve.id"> </SelectionChallengeEquipe>
        <SelectPointIntermediaires v-if="epreuve.passages_inter" :current_passage="current_passage" :current_course="course" :id_epreuve="epreuve.id" :passages="epreuve.passages_inter"></SelectPointIntermediaires>
        <SelectionCourseCumul v-if="epreuve.courses_cumul" :courses_cumul="epreuve.courses_cumul" :current_courses_cumul="current_courses_cumul" :id_epreuve="epreuve.id"></SelectionCourseCumul>
        <SelectionCourseCumulEquipe v-if="epreuve.courses_cumul_equipe" :courses_cumul_equipe="epreuve.courses_cumul_equipe" :current_courses_cumul_equipe="current_courses_cumul_equipe" :id_epreuve="epreuve.id"></SelectionCourseCumulEquipe>
      </b-col>
    </b-row>

    <TableauResultatsCourseCumulEquipe id="tableau-resultats" v-if="epreuve.resultats" :resultats="epreuve.resultats"></TableauResultatsCourseCumulEquipe>
  </b-container>
</template>

<script>
import axios from "axios";
import TopBar from "@/component/Epreuve/TopBar";
import TableauResultatsCourseCumulEquipe from "@/component/Epreuve/TableauResultatsCourseCumulEquipe";
import SelectionCourse from "@/component/Epreuve/SelectionCourse";
import SelectionChallenge from "@/component/Epreuve/SelectionChallenge";
import SelectionChallengeEquipe from "@/component/Epreuve/SelectionChallengeEquipe";
import SelectPointIntermediaires from "@/component/Epreuve/SelectPointIntermediaires";
import SelectionCourseCumul from "@/component/Epreuve/SelectionCourseCumul";
import SelectionCourseCumulEquipe from "@/component/Epreuve/SelectionCourseCumulEquipe";

export default {
  components: {
    TopBar,
    TableauResultatsCourseCumulEquipe,
    SelectionCourse,
    SelectionChallenge,
    SelectionChallengeEquipe,
    SelectPointIntermediaires,
    SelectionCourseCumul,
    SelectionCourseCumulEquipe,
  },
  watch: {
    $route: function (newVal, oldVal) {
      // watch it
      this.loading = true;
      this.init();
      this.loadDatas();
    },
  },
  data() {
    return {
      epreuve: {},
    };
  },
  methods: {
    /* Fetch data from server */
    loadDatas() {
      var _this = this;
      axios.post(this.$store.getters.base_url + "/public/courseCumulEquipe/get.php?id=" + this.id_epreuve + "&course_cumul_equipe=" + this.current_courses_cumul_equipe).then(function (response) {
        _this.loading = false;
        _this.epreuve = response.data;
      });
    },

    init() {
      this.course = "";
      this.current_passage = "";
      this.current_challenge = "";
      this.current_challenge_equipe = "";
      this.current_courses_cumul = "";
      this.current_courses_cumul_equipe = "";
      this.id_epreuve = this.$route.query.id;
      if (this.$route.query.p) {
        this.course = this.$route.query.p;
      }

      if (this.$route.query.i) {
        this.current_passage = this.$route.query.i;
      }

      if (this.$route.query.c) {
        this.current_challenge = this.$route.query.c;
      }
      if (this.$route.query.ce) {
        this.current_challenge_equipe = this.$route.query.ce;
      }
      if (this.$route.query.cc) {
        this.current_courses_cumul = this.$route.query.cc;
      }
      if (this.$route.query.cce) {
        this.current_courses_cumul_equipe = this.$route.query.cce;
      }
      this.list_cat = [];
      this.list_clubs = [];
    },
  },
  created() {
    const current_query = { ...this.$route.query };
    this.$router.replace({ path: '/epreuve', query: current_query });
    this.init();
    this.loadDatas();
  },
};
</script>

<style>
.isCurrent {
  background-color: white !important;
  color: #f29406 !important;
}
#additional-informations-bar {
  margin-bottom: 5px;
}
#additional-informations-bar p {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
  text-align: left;
  padding-left: 15px;
}
#tableau-resultats {
  font-size: 14px;
}

#tableau-resultats td {
  vertical-align: center;
}
.filter-title {
  font-size: 13px;
  margin-bottom: 10px;
  font-weight: bold;
}

#selector-bar {
  background-color: #e2e2e2;
  border: 1px solid #d8d7d7;
  border-radius: 3px;
  margin: 10px 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/CourseCumulEquipe.vue